import { View } from 'react-native';
import { tv } from '@/common/theme/tv.config';

export type TSkeletonInlineProps = {
  className?: string;
};

export function SkeletonInline({ className }: TSkeletonInlineProps) {
  return <View className={styles.root({ className })} />;
}

const styles = {
  root: tv({
    base: 'h-[2rem] w-full min-w-[2rem] animate-shimmer rounded-sm bg-gradient-to-r from-black/5 via-black/10 to-black/5 [background-size:200%_100%]',
  }),
};
